$ = jQuery;

import Swiper from 'swiper';
import { Pagination, Autoplay, Scrollbar } from 'swiper/modules';
//import Isotope from 'isotope-layout';

//import {header} from './modules/header';


$(document).ready(function() {
  


  /* ################################# */
  /* ###### START: INTERACTIONS ###### */
  /* ################################# */




  /* HERO SWIPER */
if ($('.hero-swiper').length) {
  const heroSwiper = new Swiper('.hero-swiper', {
      modules: [Pagination, Autoplay],
      spaceBetween: 2,
      loop: true,
      autoplay: {
          delay: 5000, // 5 seconds per slide
          disableOnInteraction: false,
      },
      pagination: {
          el: '.swiper-pagination',
          clickable: true,
      },
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
      speed: 600,
      on: {
          // When autoplay starts or slide changes
          autoplayStart: function() {
              updatePaginationProgress(this);
          },
          slideChange: function() {
              updatePaginationProgress(this);
          },
      },
  });

  // Function to update pagination progress
  function updatePaginationProgress(swiper) {
      // Reset all bullets by removing the filling class
      $('.swiper-pagination-bullet').removeClass('filling');

      // Get the active bullet
      const $activeBullet = $('.swiper-pagination-bullet-active');
      if ($activeBullet.length) {
          // Set the transition duration as a CSS custom property
          const autoplayDelay = swiper.params.autoplay.delay;
          $activeBullet.css('--fill-duration', `${autoplayDelay}ms`);
          // Add the filling class to trigger the animation
          $activeBullet.addClass('filling');
      }
  }
}



  // Check if elements with class .nb-email-url exist
  if ($('.nb-email-url').length) {
    // Iterate through each element with the class
    $('.nb-email-url').each(function() {
      // Get the email from data-swap attribute
      var email = $(this).attr('data-swap');
      // Update href with mailto: + email
      $(this).attr('href', 'mailto:' + email);
      // Replace inner HTML with the email
      $(this).html(email);
    });
  }

  /* ####################################### */
  /* ### START INTERACTIONS - GENERAL    ### */
  /* ####################################### */

  /* START: HAMBURGER MENU */
  $(document).on("click", "header .hamburger", function () {
    let burger = $(this);
    let cart = $('.sidebar-wrapper.cart');
    let nav = $('.nav-wrapper nav ul');
    let header = $('header');

    if(burger.hasClass('is-active')){
      if(!cart.hasClass('closed')){
        cart.addClass('closed');
      }
      burger.removeClass('is-active');
      nav.removeClass('open');
      header.removeClass('open');
    }else{
      burger.addClass('is-active');
      nav.addClass('open');
      header.addClass('open');
    }
  });
  /* END: HAMBURGER MENU */

  /* START: TOGGLE CART */
  $(document).on("click", ".sidebar-cover", function () {
    let cart = $('.sidebar-wrapper.cart');
    let header = $('header');
    let burger = $('header .hamburger');
    cart.addClass('closed');
    header.removeClass('open');
    burger.removeClass('is-active');
  });
  $(document).on("click", ".cart-toggle", function () {
    let burger = $('header .hamburger');
    let cart = $('.sidebar-wrapper.cart');
    let header = $('header');
    let nav = $('.nav-wrapper nav ul');
    if (header.hasClass('open')){
      header.removeClass('open');
      nav.removeClass('open');
      cart.removeClass('closed');
      burger.addClass('is-active');
    }else{
      cart.removeClass('closed');
      burger.addClass('is-active');
    }
  });
  $(document).on("click", ".sidebar-wrapper .close-sidebar", function () {
    $(this).closest('.sidebar-wrapper').addClass('closed');
  });
  /* END: TOGGLE CART */


  /* START: FAQ SECTION */
  $(document).on("click", "section .faq .question-wrapper", function () {
    $(this).siblings().removeClass('open');
    $(this).toggleClass('open');
  });
  /* END: FAQ SECTION */

  /* ####################################### */
  /* ### END   INTERACTIONS - GENERAL    ### */
  /* ####################################### */





  /* ####################### */
  /* ### START SWIPER    ### */
  /* ####################### */

  if($('.product-swiper .swiper').length){
    const testimonialSwiper = new Swiper('.product-swiper .swiper', {
      modules: [Pagination, Autoplay],
      slidesPerView: 1,
      spaceBetween: 32,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }

  /* ####################### */
  /* ### END   SWIPER    ### */
  /* ####################### */





  /* ############################## */
  /* ###### START: FRESHCHAT ###### */
  /* ############################## */
  /* ----FLYTTET TIL FOOTER.PHP---- */
  /* ############################## */
  /* ###### END:   FRESHCHAT ###### */
  /* ############################## */


   


    function repaintCart(response) {
      if (response.success) {
          $(".sidebar-wrapper.cart .sidebar .inner").html(response.data.content);
          $(".cart-toggle .cart-qty").html(response.data.qty);
      } else {
          console.error('Error:', response.data.message);
      }
    }
  
    $(document).on('click', '.remove-item', function(e) {
      e.preventDefault();
      var $cartItem = $(this).closest('.cart-item');
      var cartItemKey = $cartItem.data('attr-cart-item-key');

      $.ajax({
          url: wc_add_to_cart_params_2.ajax_url,
          type: 'POST',
          dataType: "json",
          data: {
              action: 'nb_remove_cart_item',
              cart_item_key: cartItemKey,
              nonce: wc_add_to_cart_params_2.nonce
          },
          beforeSend: function() {
              $cartItem.addClass('loading');
          },
          success: function(response) {
              repaintCart(response);
          },
          complete: function() {
              $cartItem.removeClass('loading');
          }
      });
  });

  // Increase quantity
  $(document).on('click', '.plus', function(e) {
      e.preventDefault();
      var $cartItem = $(this).closest('.cart-item');
      var cartItemKey = $cartItem.data('attr-cart-item-key');
      var $qtyInput = $cartItem.find('.qty');
      var currentQty = parseInt($qtyInput.val());
      var newQty = currentQty + 1;

      $.ajax({
          url: wc_add_to_cart_params_2.ajax_url,
          type: 'POST',
          dataType: "json",
          data: {
              action: 'nb_update_cart_quantity',
              cart_item_key: cartItemKey,
              quantity: newQty,
              nonce: wc_add_to_cart_params_2.nonce
          },
          beforeSend: function() {
              $cartItem.addClass('loading');
          },
          success: function(response) {
              repaintCart(response);
          },
          complete: function() {
              $cartItem.removeClass('loading');
          }
      });
  });

  // Decrease quantity
  $(document).on('click', '.minus', function(e) {
      e.preventDefault();
      var $cartItem = $(this).closest('.cart-item');
      var cartItemKey = $cartItem.data('attr-cart-item-key');
      var $qtyInput = $cartItem.find('.qty');
      var currentQty = parseInt($qtyInput.val());
      var newQty = currentQty - 1;

      if (newQty < 1) return; // Prevent going below 1

      $.ajax({
          url: wc_add_to_cart_params_2.ajax_url,
          type: 'POST',
          dataType: "json",
          data: {
              action: 'nb_update_cart_quantity',
              cart_item_key: cartItemKey,
              quantity: newQty,
              nonce: wc_add_to_cart_params_2.nonce
          },
          beforeSend: function() {
              $cartItem.addClass('loading');
          },
          success: function(response) {
              repaintCart(response);
          },
          complete: function() {
              $cartItem.removeClass('loading');
          }
      });
  });

  // Optional: Manual quantity input change
  $(document).on('change', '.qty', function() {
      var $cartItem = $(this).closest('.cart-item');
      var cartItemKey = $cartItem.data('attr-cart-item-key');
      var newQty = parseInt($(this).val());

      if (newQty < 1) {
          $(this).val(1);
          newQty = 1;
      }

      $.ajax({
          url: wc_add_to_cart_params_2.ajax_url,
          type: 'POST',
          dataType: "json",
          data: {
              action: 'nb_update_cart_quantity',
              cart_item_key: cartItemKey,
              quantity: newQty,
              nonce: wc_add_to_cart_params_2.nonce
          },
          beforeSend: function() {
              $cartItem.addClass('loading');
          },
          success: function(response) {
              repaintCart(response);
          },
          complete: function() {
              $cartItem.removeClass('loading');
          }
      });
  });


$(document).on('click', '.nb-add-to-cart', function(e) {
    e.preventDefault();
    var $button = $(this);
    var productId = $button.attr('data-attr-product-id');
    var quantity = 1;
    var mainProductId = $button.attr('data-main-product-id') || '';
    var oppstartPrice = $button.attr('data-oppstart-price') || '';
    var oppstartName = $button.attr('data-oppstart-name') || '';

    console.log('Cart Data:', {
        product_id: productId,
        quantity: quantity,
        main_product_id: mainProductId,
        oppstart_price: oppstartPrice,
        oppstart_name: oppstartName
    });

    $.ajax({
        url: wc_add_to_cart_params_2.ajax_url,
        type: 'POST',
        dataType: 'json',
        data: {
            action: 'nb_add_to_cart',
            product_id: productId,
            quantity: 1,
            main_product_id: mainProductId,
            oppstart_price: oppstartPrice,
            oppstart_name: oppstartName,
            nonce: wc_add_to_cart_params_2.nonce
        },
        beforeSend: function() {
            $button.addClass('loading');
        },
        success: function(response) {
            if (response.success) {
                console.log('Ajax Success:', response);
                repaintCart(response);
                $('header .cart-toggle').trigger('click');
            }
        },
        complete: function() {
            $button.removeClass('loading');
        },
        error: function(xhr, status, error) {
            console.error('Add to Cart Error:', status, error);
        }
    });
});

$(document).on('click', '.single_add_to_cart_button', function(e) {
  e.preventDefault();
  var $button = $(this);
  let variation_id = $(this).parent().find("input.variation_id").val();
  let product_id = $(this).parent().find("input[name='product_id']").val();
  let quantity = $(this).parent().find("input.qty").val();


  $.ajax({
    url: wc_add_to_cart_params_2.ajax_url,
    type: 'POST',
    dataType: "json",
    data: {
        action: 'nb_add_to_cart',
        product_id: product_id,
        quantity: quantity,
        nonce: wc_add_to_cart_params_2.nonce,
        variation_id:variation_id
    },
    beforeSend: function() {
        $button.addClass('loading');
    },
    success: function(response) {
      repaintCart(response);
      $('header .cart-toggle').trigger('click');
    },
    complete: function() {
        $button.removeClass('loading');
    },
    error: function(xhr, status, error) {
        console.error('Add to Cart Error:', status, error);
    }
});



});






/* START LIGHTBOX */
// Check if #lightbox exists
if ($('#lightbox').length) {
  const $lightbox = $('#lightbox');
  const $lightboxImage = $('.lightbox-image');
  const $closeButton = $('.lightbox-close');
  const $prevButton = $('.lightbox-prev');
  const $nextButton = $('.lightbox-next');
  let currentIndex = 0;
  let images = [];

  // Collect all image sources from Swiper slides
  images = $('.swiper-slide img').map(function() {
    return $(this).attr('src');
  }).get();

  // Open lightbox when clicking the zoom button
  $('.open-zoom-modal').on('click', function() {
    currentIndex = $(this).closest('.swiper-slide').index();
    $lightboxImage.attr('src', images[currentIndex]);
    $lightbox.fadeIn();
  });

  // Close lightbox
  $closeButton.on('click', function() {
    $lightbox.fadeOut();
  });

  // Close lightbox when clicking outside the image
  $lightbox.on('click', function(e) {
    if (e.target === this) {
      $lightbox.fadeOut();
    }
  });

  // Navigate to previous image
  $prevButton.on('click', function() {
    currentIndex = (currentIndex - 1 + images.length) % images.length;
    $lightboxImage.attr('src', images[currentIndex]);
  });

  // Navigate to next image
  $nextButton.on('click', function() {
    currentIndex = (currentIndex + 1) % images.length;
    $lightboxImage.attr('src', images[currentIndex]);
  });

  // Keyboard navigation
  $(document).on('keydown', function(e) {
    if ($lightbox.is(':visible')) {
      if (e.key === 'ArrowLeft') {
        $prevButton.trigger('click');
      } else if (e.key === 'ArrowRight') {
        $nextButton.trigger('click');
      } else if (e.key === 'Escape') {
        $closeButton.trigger('click');
      }
    }
  });
}
/* END LIGHTBOX */




});